// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar__1k-yw","md":"md__289Of","lg":"lg__2DBMY","fallback":"fallback__2jcay"};